/* Moves the grid-view toggle into the collection toolbar row,
   right after the product count, so spacing is automatic. */
(function () {
  function moveToggle() {
    var toggle = document.querySelector('.etq-grid-toggle');
    var count = document.querySelector('.facets-container .product-count');
    if (!toggle || !count) return;
    if (toggle.dataset.etqMoved) return;

    count.insertAdjacentElement('afterend', toggle);
    toggle.dataset.etqMoved = '1';
    toggle.classList.remove('page-width');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveToggle);
  } else {
    moveToggle();
  }
})();